import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getPortDestinationAgentList(params) {
  return request({
    url: URL.partner.portDestinationAgent,
    method: 'get',
    params
  })
}

export function savePortDestinationAgent(data) {
  return request({
    url: URL.partner.portDestinationAgent,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function delPortDestinationAgent(uuid) {
  return request({
    url: URL.partner.portDestinationAgent + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}
